<div class="container-fluid">
  <section>
    <h1 class="text-center">{{docId ? 'Update Centre Counselling Log':' Add Centre Counselling Log'}}</h1>

    <form [formGroup]="centreLogForm">
      <div class="row">
        <!-- Centre Selection -->
        <ng-container>
          <app-searchable-select class="col-md-12"
                                 *ngIf="!docId; else readonlyCentre"
                                 [options]="allCenters$ | async"
                                 [selectedValue]="selectedCentre"
                                 [displayWithFn]="displayCentre"
                                 [placeholder]="'Select Centre'"
                                 [label]="'Select Centre'"
                                 (selectionChange)="onCentreSelect($event)">
          </app-searchable-select>
          <ng-template #readonlyCentre>
            <mat-form-field appearance="outline" class="col-md-12">
              <mat-label>Centre</mat-label>
              <input matInput formControlName="centreName" readonly />
            </mat-form-field>
          </ng-template>
        </ng-container>
      </div>

      <!-- EDIT MODE - Single Entry Form -->
      <div *ngIf="docId" class="row">
        <!-- Select Child -->
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Select Child</mat-label>
          <input matInput formControlName="childName" readonly/>
        </mat-form-field>

        <!-- Select Session -->
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Select Session</mat-label>
          <mat-select formControlName="session">
            <mat-option *ngFor="let s of sessions" [value]="s" class="session-option">
              {{ s }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Select Type -->
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Select Type</mat-label>
          <mat-select formControlName="type">
            <mat-option *ngFor="let t of types" [value]="t" [ngClass]="getTypeClass(t)">
              {{ t }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Date -->
        <mat-form-field appearance="outline" class="col-md-4">
          <mat-label>Date</mat-label>
          <input matInput [matDatepicker]="picker" formControlName="date">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!-- Remark -->
        <mat-form-field appearance="outline" class="col-md-12">
          <mat-label>Remark</mat-label>
          <textarea matInput formControlName="remark" rows="2"></textarea>
        </mat-form-field>
      </div>

      <!-- ADD MODE - Multiple Entries Table -->
      <div *ngIf="!docId" class="row mt-3">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <h4>Children Entries</h4>
            <button type="button" mat-raised-button color="accent" (click)="addEntry()" [disabled]="childData.length === 0">
              <mat-icon>add</mat-icon>
              Add Entry
            </button>
          </div>

          <div class="table-container mat-elevation-z2">
            <table mat-table [dataSource]="tableDataSource" class="w-100">

              <!-- Child Column -->
              <ng-container matColumnDef="child">
                <th mat-header-cell *matHeaderCellDef>Child *</th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select (selectionChange)="onChildSelectInRow($event, i)" required>
                      <mat-option *ngFor="let child of childData" [value]="child"
                                  [ngClass]="{ 'yellow': (child?.admissionData?.length ?? 0) > 2 }">
                        {{ child.firstName }} {{ child.lastName }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="element.get('childName')?.hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Session Column -->
              <ng-container matColumnDef="session">
                <th mat-header-cell *matHeaderCellDef>Session *</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="session" required>
                      <mat-option *ngFor="let s of sessions" [value]="s" class="session-option">
                        {{ s }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="element.get('session')?.hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Type Column -->
              <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>Type *</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-select formControlName="type" required>
                      <mat-option *ngFor="let t of types" [value]="t" [ngClass]="getTypeClass(t)">
                        {{ t }}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="element.get('type')?.hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Date Column -->
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date *</th>
                <td mat-cell *matCellDef="let element; let i = index" [formGroup]="element">
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput [matDatepicker]="datePicker" formControlName="date" required>
                    <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
                    <mat-datepicker #datePicker></mat-datepicker>
                    <mat-error *ngIf="element.get('date')?.hasError('required')">
                      Required
                    </mat-error>
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Remark Column -->
              <ng-container matColumnDef="remark">
                <th mat-header-cell *matHeaderCellDef>Remark</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element">
                  <mat-form-field appearance="outline" class="w-100">
                    <input matInput formControlName="remark" placeholder="Entre Remark">
                  </mat-form-field>
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element; let i = index">
                  <button type="button" mat-icon-button color="warn"
                          (click)="removeEntry(i)" matTooltip="Remove">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

              <!-- No Data Row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell text-center py-3" [attr.colspan]="displayedColumns.length">
                  <p class="text-muted">No entries added. Select a centre and click "Add Entry" to begin.</p>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <!-- Buttons -->
      <div class="row mt-3">
        <div class="col-md-12 d-flex justify-content-center gap-2">
          <button mat-raised-button color="primary"
                  [disabled]="centreLogForm.invalid || isLoading || (!docId && entries.length === 0)"
                  (click)="onSubmit()">
            {{ docId ? 'Update':'Submit' }}
          </button>
          <button mat-button color="warn" (click)="onCancel()">
            Cancel
          </button>
        </div>
      </div>

    </form>
    <!-- Loading Spinner -->
    <div class="spinner-container" *ngIf="isLoading">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </section>
</div>
